import z from 'zod';
import { SyncFieldValidator } from './types';

export const errorMessage = 'error.required';

const required: SyncFieldValidator = function required(
  value: unknown,
): string | undefined {
  if (!value) {
    return errorMessage;
  }

  return undefined;
};

export const requiredForMonetaryValues = function requiredForMonetaryValues(
  value: unknown,
): string | undefined {
  if (!value && value !== 0) {
    return errorMessage;
  }

  return undefined;
};

export const createRequiredField = (message = errorMessage) =>
  z.string(message).min(1, message);

export const requiredField = createRequiredField();

export default required;
